
$(document).ready(function () {
    loadFooter(customHeader);
});
function customHeader() {

    $('#footer .registrationBanner:not(.registrationBanner--extra)').clone().appendTo('#customerLogin');
    $('#customerLogin .csrf-enabled').prepend($('h2#loginHeading'));
    $('#customerLogin label[for="email"]').html(translation('email') + '<span>*</span>');
    $('#customerLogin label[for="password"]').html(translation('heslo') + '<span>*</span>');
    $('#customerLogin .btn-login').closest('.form-group').after($('.alternative-links'));
    $('#customerLogin .social-login-buttons-divider span').text(translation('neboSePrihlastePomoci'));
    $('.alternative-links a:last-child').text(translation('zapomenuteHeslo'));
    $('<span class="close"></span>').appendTo('.login-widget .popup-widget-inner');

    $(document).on("click", ".login-widget .popup-widget-inner .close", function () {
        $('body').removeClass('user-action-visible login-window-visible')
    })
}











$(document).ready(function () {
    if ($('.cart-empty').length) {

        if (!$('.hpBannerTopCategories').length) {
            //    sessionStorage.removeItem('loadedCategories');
            //     sessionStorage.removeItem('loadedTopBrands');
            if (sessionStorage.loadedCategories) {
                $('.cart-inner.cart-empty').append('<div class="hpBannerTopCategories">' + sessionStorage.loadedCategories + '</div>');
                if (sessionStorage.loadedTopBrands) {
                    $('.cart-inner.cart-empty').append('<div class="topBrands">' + sessionStorage.loadedTopBrands + '</div>');
                }
                slickItems();
            } else {
                // Jinak načti AJAXem
                $.ajax({
                    type: "GET",
                    dataType: "html",
                    timeout: 10000,
                    cache: true,
                    url: "/",
                    success: function (e) {
                        var doc = shoptet.common.createDocumentFromString(e);

                        // Kategorie
                        var categoriesHtml = $(doc).find(".benefitBanner.position--benefitHomepage .hpBannerTopCategories").html();
                        if (categoriesHtml !== null) {
                            $('.cart-inner.cart-empty').append('<div class="hpBannerTopCategories">' + categoriesHtml + '</div>');
                            sessionStorage.loadedCategories = categoriesHtml;
                        }

                        // Značky
                        var brandsHtml = $(doc).find(".benefitBanner.position--benefitHomepage .topBrands").html();
                        if (brandsHtml !== null) {
                            $('.cart-inner.cart-empty').append('<div class="topBrands">' + brandsHtml + '</div>');
                            sessionStorage.loadedTopBrands = brandsHtml;
                        }

                        slickItems();
                    }
                });
            }
        } else {
            slickItems();
        }
    }
});


document.addEventListener('ShoptetDOMContentLoaded', function () {
    if ($('.cart-empty').length) {


        if (!$('.hpBannerTopCategories').length) {
            //    sessionStorage.removeItem('loadedCategories');
            //     sessionStorage.removeItem('loadedTopBrands');
            if (sessionStorage.loadedCategories) {
                $('.cart-inner.cart-empty').append('<div class="hpBannerTopCategories">' + sessionStorage.loadedCategories + '</div>');
                if (sessionStorage.loadedTopBrands) {
                    $('.cart-inner.cart-empty').append('<div class="topBrands">' + sessionStorage.loadedTopBrands + '</div>');
                }
                slickItems();
            } else {
                // Jinak načti AJAXem
                $.ajax({
                    type: "GET",
                    dataType: "html",
                    timeout: 10000,
                    cache: true,
                    url: "/",
                    success: function (e) {
                        var doc = shoptet.common.createDocumentFromString(e);

                        // Kategorie
                        var categoriesHtml = $(doc).find(".benefitBanner.position--benefitHomepage .hpBannerTopCategories").html();
                        if (categoriesHtml !== null) {
                            $('.cart-inner.cart-empty').append('<div class="hpBannerTopCategories">' + categoriesHtml + '</div>');
                            sessionStorage.loadedCategories = categoriesHtml;
                        }

                        // Značky
                        var brandsHtml = $(doc).find(".benefitBanner.position--benefitHomepage .topBrands").html();
                        if (brandsHtml !== null) {
                            $('.cart-inner.cart-empty').append('<div class="topBrands">' + brandsHtml + '</div>');
                            sessionStorage.loadedTopBrands = brandsHtml;
                        }

                        slickItems();
                    }
                });
            }
        } else {
            slickItems();
        }
    }

})



function slickItems() {

    $('.hpBannerCategoryList').slick({
        slidesToShow: 6,
        slidesToScroll: 1,
        centerMode: false,
        autoplay: false,
        autoplaySpeed: 5000,
        dots: false,
        arrows: true,
        infinite: false,
        adaptiveHeight: false,
        responsive: [
            { breakpoint: 1200, settings: { slidesToShow: 4.4, slidesToScroll: 1 } },
            { breakpoint: 992, settings: { slidesToShow: 3.4, slidesToScroll: 1 } },
            { breakpoint: 768, settings: "unslick" }
        ]
    });
    $('.topBrands .brandFeed').slick({
        slidesToShow: 10,
        slidesToScroll: 1,
        centerMode: false,
        autoplay: false,
        autoplaySpeed: 5000,
        dots: false,
        arrows: true,
        infinite: false,
        adaptiveHeight: false,
        responsive: [
            { breakpoint: 1440, settings: { slidesToShow: 10, slidesToScroll: 1 } },
            { breakpoint: 1200, settings: { slidesToShow: 8, slidesToScroll: 1 } },
            { breakpoint: 992, settings: { slidesToShow: 6, slidesToScroll: 1 } },
            { breakpoint: 768, settings: { slidesToShow: 5, slidesToScroll: 1 } },
            { breakpoint: 480, settings: { slidesToShow: 3.4, slidesToScroll: 1 } },
            { breakpoint: 340, settings: { slidesToShow: 2.4, slidesToScroll: 1 } }
        ]
    });

}







document.addEventListener("ShoptetDOMAdvancedOrderLoaded", function () {
    $(".h1.advanced-order-suggestion").text(translation('sTimtoProduktem'));
    $('.advancedOrder__buttons').append($('.extras-wrap'));
    $("#cboxContent #products").slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        centerMode: false,
        autoplay: false,
        autoplaySpeed: 5000,
        dots: false,
        arrows: true,
        infinite: false,
        adaptiveHeight: false,
        responsive: [
            { breakpoint: 1199, settings: { slidesToShow: 3, slidesToScroll: 1 } },
            { breakpoint: 991, settings: { slidesToShow: 2.2, slidesToScroll: 2 } },
            { breakpoint: 580, settings: { slidesToShow: 1.2, slidesToScroll: 1 } },
            { breakpoint: 300, settings: { slidesToShow: 1, slidesToScroll: 1 } }
        ],
    });

})